/**
 * @desc 传入登录权限信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.PermissionInsertRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/userPermission/insertPermission',
    data,
  });
}

export function mock(
  data: Array<defs.PermissionInsertRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/userPermission/insertPermission',
    data,
  });
}
